"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReloadFailedError = exports.UnableToAddHostsError = exports.AddHostsApiError = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const UnableToAddHostsError = ({ onTryAgain }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        "Temporarily unable to add hosts",
        react_1.default.createElement("br", null),
        "We're waiting for your recently installed cluster to report its metrics.",
        ' ',
        react_1.default.createElement(react_core_1.Button, { variant: 'link', isInline: true, onClick: onTryAgain }, "Try again"),
        ' ',
        "in a few minutes."));
};
exports.UnableToAddHostsError = UnableToAddHostsError;
const ReloadFailedError = ({ onTryAgain }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        "Failed to reload cluster data.",
        react_1.default.createElement("br", null),
        "Check your connection and",
        ' ',
        react_1.default.createElement(react_core_1.Button, { variant: 'link', isInline: true, onClick: onTryAgain }, "try again"),
        "."));
};
exports.ReloadFailedError = ReloadFailedError;
const AddHostsApiError = ({ isImport, onTryAgain }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isImport
            ? 'Failed to create wrapping cluster for adding new hosts.'
            : 'Failed to fetch cluster for adding new hosts.',
        react_1.default.createElement("br", null),
        "Check your connection and",
        ' ',
        react_1.default.createElement(react_core_1.Button, { variant: 'link', isInline: true, onClick: onTryAgain }, "try again"),
        "."));
};
exports.AddHostsApiError = AddHostsApiError;
//# sourceMappingURL=HostsClusterDetailTabContentErrors.js.map